import PaymentSlipsExport from './views/PaymentSlipsExport.vue'

export const PaymentSlipsExportRoutes = [
  {
    path: '/payment-slips-export',
    name: 'PaymentSlipsExport',
    component: PaymentSlipsExport,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'report:list',
      featureFlag: 'new_payment_slips'
    }
  }
]
